import { render } from "./VIcon.vue?vue&type=template&id=9d017468&scoped=true"
import script from "./VIcon.vue?vue&type=script&lang=js"
export * from "./VIcon.vue?vue&type=script&lang=js"

import "./VIcon.vue?vue&type=style&index=0&id=9d017468&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d017468"]])

export default __exports__